import styled from 'styled-components';

import { baseColor, darkBaseColor, primaryColor, lightPrimaryColor } from 'views/services/color-scheme';
import backgroundImage from './assets/background-image.gif';

export const Background = styled.div`
  background-image: url(${backgroundImage});
  background-position: center top;
  height: 2586px;
`;

export const Heading = styled.div`
  position: absolute;
  left: 47px;
  top: 42px;
`;

export const Table = styled.div`
  & > table {
    width: 838px;
    border-collapse: collapse;
    table-layout: fixed;
    & > thead {
      & > tr {
        & > th {
          padding: 3px 5px;
          border-right: 3px solid ${baseColor};
          border-bottom: 3px solid ${baseColor};
          text-align: center;
          background-color: ${primaryColor};
          color: ${baseColor};
          font-weight: normal;
        }
      }
    }
    & > tbody {
      & > tr {
        & > th, & > td {
          padding: 3px 5px;
          border-right: 3px solid ${baseColor};
          border-bottom: 3px solid ${baseColor};
        }
        &:nth-child(odd) {
          background-color: ${lightPrimaryColor};
        }
        &:nth-child(even) {
          background-color: ${darkBaseColor};
        }
      }
    }
  }
`;

export const Summary = styled.div`
  & > h2 {
    position: absolute;
    left: 62px;
    top: 93px;
  }
  & > ${Table} {
    position: absolute;
    left: 44px;
    top: 139px;
  }
`;

export const AVPiece = styled.div`
  & > h2 {
    position: absolute;
    left: 62px;
    top: 349px;
  }
  & > div {
    & > div:nth-child(1) {
      position: absolute;
      left: 44px;
      top: 395px;
    }
    & > div:nth-child(2) {
      position: absolute;
      left: 469px;
      top: 395px;
    }
  }
`;

export const LCDPiece = styled.div`
  & > h2 {
    position: absolute;
    left: 62px;
    top: 849px;
  }
  & > div {
    position: absolute;
    left: 44px;
    top: 895px;
  }
`;

export const LensPiece = styled.div`
  & > h2 {
    position: absolute;
    left: 500px;
    top: 849px;
  }
  & > div {
    position: absolute;
    left: 484px;
    top: 895px;
  }
`;

export const CarPiece = styled.div`
  & > h2 {
    position: absolute;
    left: 62px;
    top: 1329px;
  }
  & > div {
    & > div:nth-child(1) {
      position: absolute;
      left: 44px;
      top: 1375px;
    }
    & > div:nth-child(2) {
      position: absolute;
      left: 469px;
      top: 1375px;
    }
  }
`;

export const PrecisionPiece = styled.div`
  & > h2 {
    position: absolute;
    left: 62px;
    top: 1787px;
  }
  & > div {
    & > div:nth-child(1) {
      position: absolute;
      left: 44px;
      top: 1833px;
    }
    & > div:nth-child(2) {
      position: absolute;
      left: 328px;
      top: 1833px;
    }
    & > div:nth-child(3) {
      position: absolute;
      left: 612px;
      top: 1833px;
    }
  }
`;

export const ContainerPiece = styled.div`
  & > h2 {
    position: absolute;
    left: 62px;
    top: 2141px;
  }
  & > div {
    position: absolute;
    left: 44px;
    top: 2187px;
  }
`;

export const Equipment = styled.div`
  a:hover {
    opacity: 0.75;
  }
  & > h2 {
    position: absolute;
    left: 500px;
    top: 2141px;
  }
  & > a {
    position: absolute;
    left: 484px;
    top: 2187px;
  }
`;

export const Contact = styled.div`
  a {
    color: ${primaryColor};
    text-decoration: underline;
    &:hover {
      opacity: 0.75;
    }
  }
  & > h2 {
    position: absolute;
    left: 500px;
    top: 2370px;
  }
  & > p {
    position: absolute;
    left: 484px;
    top: 2413px;
  }
  & > table {
    position: absolute;
    left: 499px;
    top: 2465px;
    & > tbody {
      & > tr {
        & > th {
          padding: 5px 15px 0 0;
          font-weight: normal;
        }
        & > td {
          padding: 5px 0 0 0;
          font-weight: normal;
        }
      }
    }
  }

`;
